//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'showItem',
  props: ['resource', 'index', 'minimal', 'ratio', 'slug', 'type', 'thumb'],
  components: {
    thumb: () => import('~/components/thumb')
  },
  methods: {
    favorite(resource) {
      this.$emit('toggleFavorite', resource)
    }
  }
}
